/* Profil-Konfigurator für LED-Alu-Profile.
   Eigenständig, getrennt vom Band-Konfigurator in led.js.

   Ablauf wie beim Band-Tool: Schritt wählen → Schritt schließt, nächster öffnet.
   1. Länge (fest)  2. Form der Abdeckung  3. Farbe  4. Endkappen  5. Kauf */
(function () {
  var root = document.querySelector('[data-alu]');
  if (!root || root.dataset.aluReady) return;
  root.dataset.aluReady = '1';

  var profilId = root.dataset.profilVariant;
  var profilPreis = parseInt(root.dataset.profilPreis, 10) || 0;

  var summeEl = root.querySelector('[data-alu-sum]');
  var qtyEl = root.querySelector('[data-alu-qty]');
  var knopf = root.querySelector('[data-alu-add]');

  var schrittForm = root.querySelector('[data-alu-step="form"]');
  var schrittFarbe = root.querySelector('[data-alu-step="color"]');
  var schrittKappen = root.querySelector('[data-alu-step="caps"]');

  var farbPicker = root.querySelector('[data-alu-color-picker]');
  var farbHinweis = root.querySelector('[data-alu-color-hint]');
  var kappenPicker = root.querySelector('[data-alu-caps-picker]');
  var kappenHinweis = root.querySelector('[data-alu-caps-hint]');

  function euro(cent) {
    return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function gewaehlt(name) {
    var el = root.querySelector('input[name="' + name + '"]:checked');
    if (!el || !el.value) return null;
    return { id: el.value, preis: parseInt(el.dataset.preis, 10) || 0, name: el.dataset.name || '' };
  }

  function formGewaehlt() {
    var el = root.querySelector('input[name="alu-form"]:checked');
    return el ? el.value : '';
  }

  function menge() {
    var n = parseInt(qtyEl && qtyEl.value, 10);
    return isNaN(n) || n < 1 ? 1 : Math.min(n, 99);
  }

  var ansicht = '2d';
  var mitMassen = false;

  function bildAdresse(form) {
    var radio = root.querySelector('input[name="alu-form"]:checked');
    var hatEigenes = radio && radio.dataset.bild;
    if (ansicht === '3d') {
      if (hatEigenes && radio.dataset.bild3d) return radio.dataset.bild3d;
      return root.dataset['3d' + (form ? form.charAt(0).toUpperCase() + form.slice(1) : 'Leer')] || root.dataset['3dLeer'];
    }
    if (mitMassen) {
      if (hatEigenes && radio.dataset.bildmass) return radio.dataset.bildmass;
      return root.dataset['massbild' + (form ? form.charAt(0).toUpperCase() + form.slice(1) : 'Leer')] || root.dataset.massbildLeer;
    }
    if (hatEigenes) return radio.dataset.bild;
    return form ? root.dataset['src' + form] : root.dataset.srcLeer;
  }

  function vorschau(form) {
    var img = root.querySelector('[data-alu-preview-img]');
    var note = root.querySelector('[data-alu-preview-note]');
    var name = root.querySelector('input[name="alu-form"]:checked');
    var kappen = gewaehlt('alu-caps');

    if (img) {
      var url = bildAdresse(form);
      if (url && img.getAttribute('src') !== url) img.src = url;
    }
    if (note) {
      if (!form) {
        note.textContent = 'Profil · 14 × 7 mm';
      } else {
        var mass = root.dataset['mass' + form] || '';
        note.textContent = 'Abdeckung ' + (name ? (name.dataset.name || '') : '') +
          (mass ? ' · ' + mass : '') + (kappen ? ' · mit Endkappen' : '') +
          (mitMassen ? ' · bemaßt' : '');
      }
    }
  }

  function zustaende() {
    var formFertig = root.dataset.formTouched === '1';
    var farbeFertig = root.dataset.coverTouched === '1';
    var kappenFertig = root.dataset.capsTouched === '1';
    var ohneAbdeckung = !formGewaehlt();

    if (schrittForm) {
      schrittForm.classList.toggle('is-done', formFertig);
      schrittForm.dataset.state = formFertig ? 'done' : 'current';
    }
    if (schrittFarbe) {
      schrittFarbe.classList.toggle('is-done', farbeFertig);
      schrittFarbe.dataset.state = farbeFertig ? 'done'
        : (!formFertig ? 'todo' : (ohneAbdeckung ? 'todo' : 'current'));
    }
    if (schrittKappen) {
      schrittKappen.classList.toggle('is-done', kappenFertig);
      schrittKappen.dataset.state = kappenFertig ? 'done'
        : (farbeFertig ? 'current' : 'todo');
    }
  }

  function oeffne(el) {
    if (el) el.open = true;
  }
  function schliesse(el) {
    if (el) el.open = false;
  }

  /* Schritt 2 → 3: Farben der gewählten Form einblenden */
  function farbenZeigen() {
    var form = formGewaehlt();
    var wert = root.querySelector('[data-alu-form-value]');
    var name = root.querySelector('input[name="alu-form"]:checked');

    if (wert) wert.textContent = form ? (name.dataset.name || '') : 'Ohne';

    if (!form) {
      if (farbPicker) farbPicker.hidden = true;
      if (farbHinweis) {
        farbHinweis.hidden = false;
        farbHinweis.textContent = 'Ohne Abdeckung — hier ist keine Farbe nötig.';
      }
      schliesse(schrittFarbe);
      schliesse(schrittKappen);
      var leer = root.querySelector('input[name="alu-cover"][value=""]');
      if (leer) leer.checked = true;
      var leerK = root.querySelector('input[name="alu-caps"][value=""]');
      if (leerK) leerK.checked = true;
      return;
    }

    if (farbPicker) {
      farbPicker.hidden = false;
      farbPicker.querySelectorAll('[data-form]').forEach(function (el) {
        el.hidden = el.dataset.form !== form;
      });
    }
    if (farbHinweis) farbHinweis.hidden = true;
    vorschau(form);

    // Auswahl zurücksetzen, wenn sie nicht mehr zur Form passt
    var aktiv = root.querySelector('input[name="alu-cover"]:checked');
    if (aktiv && aktiv.value && aktiv.dataset.form !== form) {
      var leer2 = root.querySelector('input[name="alu-cover"][value=""]');
      if (leer2) leer2.checked = true;
    }
  }

  /* Schritt 3 → 4: Endkappen derselben Form */
  function kappenZeigen() {
    var form = formGewaehlt();
    var abdeckung = gewaehlt('alu-cover');
    var wert = root.querySelector('[data-alu-color-value]');
    if (wert) wert.textContent = abdeckung ? abdeckung.name.split(' · ').pop() : '';

    if (!form || !abdeckung) {
      if (kappenPicker) kappenPicker.hidden = true;
      if (kappenHinweis) {
        kappenHinweis.hidden = false;
        kappenHinweis.textContent = 'Wähle zuerst Form und Farbe der Abdeckung.';
      }
      schliesse(schrittKappen);
      return;
    }

    if (kappenPicker) {
      kappenPicker.hidden = false;
      kappenPicker.querySelectorAll('[data-form]').forEach(function (el) {
        el.hidden = el.dataset.form !== form;
      });
    }
    if (kappenHinweis) kappenHinweis.hidden = true;

    var aktiv = root.querySelector('input[name="alu-caps"]:checked');
    if (aktiv && aktiv.value && aktiv.dataset.form !== form) {
      var leer = root.querySelector('input[name="alu-caps"][value=""]');
      if (leer) leer.checked = true;
    }
  }

  function summeZeichnen() {
    var abdeckung = gewaehlt('alu-cover');
    var kappen = gewaehlt('alu-caps');
    var q = menge();
    var aktuellerProfilPreis = parseInt(root.dataset.profilPreis, 10) || profilPreis;
    var gesamt = aktuellerProfilPreis + (abdeckung ? abdeckung.preis : 0) + (kappen ? kappen.preis : 0);

    var zeileA = root.querySelector('[data-alu-row="cover"]');
    if (zeileA) {
      zeileA.style.display = abdeckung ? '' : 'none';
      if (abdeckung) {
        var metaA = zeileA.querySelector('[data-alu-cover-meta]');
        var preisA = zeileA.querySelector('[data-alu-cover-price]');
        if (metaA) metaA.textContent = ' · ' + abdeckung.name;
        if (preisA) preisA.textContent = euro(abdeckung.preis);
      }
    }

    var zeileK = root.querySelector('[data-alu-row="caps"]');
    if (zeileK) {
      zeileK.style.display = kappen ? '' : 'none';
      if (kappen) {
        var metaK = zeileK.querySelector('[data-alu-caps-meta]');
        var preisK = zeileK.querySelector('[data-alu-caps-price]');
        if (metaK) metaK.textContent = ' · ' + kappen.name;
        if (preisK) preisK.textContent = euro(kappen.preis);
      }
    }

    if (summeEl) summeEl.textContent = euro(gesamt * q);
  }

  root.querySelectorAll('[data-alu-view]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      ansicht = btn.dataset.aluView;
      mitMassen = false;
      root.querySelectorAll('[data-alu-view]').forEach(function (b) {
        var aktiv = b === btn;
        b.classList.toggle('is-active', aktiv);
        b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      });
      var massBtn = root.querySelector('[data-alu-mass]');
      if (massBtn) {
        massBtn.classList.remove('is-active');
        massBtn.setAttribute('aria-pressed', 'false');
      }
      vorschau(formGewaehlt());
    });
  });

  var massBtn = root.querySelector('[data-alu-mass]');
  if (massBtn) {
    massBtn.addEventListener('click', function () {
      mitMassen = !mitMassen;
      if (mitMassen) {
        ansicht = '2d';
        root.querySelectorAll('[data-alu-view]').forEach(function (b) {
          var aktiv = b.dataset.aluView === '2d';
          b.classList.toggle('is-active', aktiv);
          b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
        });
      }
      massBtn.classList.toggle('is-active', mitMassen);
      massBtn.setAttribute('aria-pressed', mitMassen ? 'true' : 'false');
      vorschau(formGewaehlt());
    });
  }

  root.addEventListener('change', function (e) {
    var name = e.target.name;

    if (name === 'alu-form') {
      root.dataset.formTouched = '1';
      farbenZeigen();
      if (formGewaehlt()) {
        schliesse(schrittForm);
        oeffne(schrittFarbe);
      }
      kappenZeigen();
    } else if (name === 'alu-cover') {
      root.dataset.coverTouched = '1';
      kappenZeigen();
      if (gewaehlt('alu-cover')) {
        schliesse(schrittFarbe);
        oeffne(schrittKappen);
      }
    } else if (name === 'alu-caps') {
      root.dataset.capsTouched = '1';
      var wertK = root.querySelector('[data-alu-caps-value]');
      var k = gewaehlt('alu-caps');
      if (wertK) wertK.textContent = k ? k.name : 'Ohne';
      if (k) schliesse(schrittKappen);
    } else if (e.target.matches('[data-alu-qty]')) {
      // Menge
    }

    summeZeichnen();
    zustaende();
    vorschau(formGewaehlt());
  });

  root.querySelectorAll('[data-qty-dir]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyEl) return;
      var n = menge() + (btn.dataset.qtyDir === 'up' ? 1 : -1);
      qtyEl.value = Math.max(1, Math.min(99, n));
      summeZeichnen();
    });
  });

  if (knopf) {
    knopf.addEventListener('click', function () {
      var abdeckung = gewaehlt('alu-cover');
      var kappen = gewaehlt('alu-caps');
      var q = menge();
      var posten = [{ id: parseInt(root.dataset.profilVariant, 10) || profilId, quantity: q, properties: { _konfiguration: 'Profil' } }];
      if (abdeckung) posten.push({ id: abdeckung.id, quantity: q, properties: { _konfiguration: 'Abdeckung' } });
      if (kappen) posten.push({ id: kappen.id, quantity: q, properties: { _konfiguration: 'Endkappen' } });

      knopf.disabled = true;
      knopf.textContent = 'Wird hinzugefügt …';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: posten })
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (d) { throw d; }); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          knopf.disabled = false;
          knopf.textContent = 'In den Warenkorb';
        });
    });
  }


  /* --- Länge & Farbe: Variante wählen ------------------------------------- */
  var varianten = [];
  var varianteEl = root.querySelector('[data-alu-varianten]');
  try { varianten = JSON.parse((varianteEl && varianteEl.textContent) || '[]'); } catch (e) { varianten = []; }

  var auswahl = { laenge: null, farbe: null };

  function chipsMarkieren() {
    root.querySelectorAll('[data-alu-laenge]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.aluLaenge === auswahl.laenge);
      b.setAttribute('aria-pressed', b.dataset.aluLaenge === auswahl.laenge ? 'true' : 'false');
    });
    root.querySelectorAll('[data-alu-farbe]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.aluFarbe === auswahl.farbe);
      b.setAttribute('aria-pressed', b.dataset.aluFarbe === auswahl.farbe ? 'true' : 'false');
    });
    var wert = root.querySelector('[data-alu-size-value]');
    if (wert) {
      var l = (auswahl.laenge || '').replace('m', ' m').trim();
      wert.textContent = l + (auswahl.farbe ? ' · ' + auswahl.farbe : '');
    }
  }

  function chipsVerfuegbar() {
    root.querySelectorAll('[data-alu-laenge]').forEach(function (b) {
      b.disabled = !varianten.some(function (v) { return v.option2 === b.dataset.aluLaenge && v.available; });
    });
    root.querySelectorAll('[data-alu-farbe]').forEach(function (b) {
      b.disabled = !varianten.some(function (v) { return v.option1 === b.dataset.aluFarbe && v.available; });
    });
  }

  // Gibt es die Kombination nicht, die andere Achse auf einen verfügbaren Wert ziehen
  function ausgleichen() {
    var passt = varianten.some(function (v) {
      return v.option1 === auswahl.farbe && v.option2 === auswahl.laenge && v.available;
    });
    if (passt) return;
    var farbeDa = varianten.filter(function (v) { return v.option1 === auswahl.farbe && v.available; });
    var laengeDa = varianten.filter(function (v) { return v.option2 === auswahl.laenge && v.available; });
    if (laengeDa.length && !farbeDa.length) {
      auswahl.farbe = laengeDa[0].option1;
    } else if (farbeDa.length && !laengeDa.length) {
      auswahl.laenge = farbeDa[0].option2;
    } else if (laengeDa.length) {
      auswahl.farbe = laengeDa[0].option1;
    }
  }

  function laengenFilter() {
    var ziel = (auswahl.laenge || '').replace(/\s/g, '');
    var sichtbar = 0;
    root.querySelectorAll('[data-alu-cover], [data-laenge]').forEach(function (el) {
      if (!el.matches('label.aluconf__row') || el.dataset.laenge === undefined) return;
      var eigen = el.dataset.laenge;
      var passt = !eigen || !ziel || eigen === ziel;
      el.hidden = !passt;
      if (passt && eigen) sichtbar++;
    });
    var leer = root.querySelector('[data-alu-cover-empty]');
    if (leer) leer.hidden = sichtbar > 0;
    var picker = root.querySelector('[data-alu-form-picker]');
    if (picker) picker.hidden = sichtbar === 0;
  }

  function varianteSetzen() {
    laengenFilter();
    if (!auswahl.laenge || !auswahl.farbe) return;
    var treffer = varianten.filter(function (v) {
      return v.option1 === auswahl.farbe && v.option2 === auswahl.laenge;
    })[0];
    if (!treffer) return;
    root.dataset.profilVariant = treffer.id;
    root.dataset.profilPreis = treffer.price;

    var preisEl = root.querySelector('[data-alu-sum]');
    var zeile = root.querySelector('[data-alu-row="profil"] [data-alu-profil-meta]');
    if (zeile) zeile.textContent = ' ' + auswahl.laenge.replace('m', ' m').trim() + ' · ' + auswahl.farbe;
    var profilPreis = root.querySelector('[data-alu-row="profil"] [data-alu-profil-price]');
    if (profilPreis) profilPreis.textContent = euro(treffer.price);

    var liefer = root.querySelector('[data-alu-liefer]');
    if (liefer) {
      liefer.textContent = 'Das Profil wird in ' + auswahl.laenge.replace('m', ' m').trim() +
        ' am Stück geliefert; Zuschnitt auf Wunsch auf Anfrage.';
    }
    document.querySelectorAll('[data-total]').forEach(function (el) {
      el.textContent = euro(treffer.price);
    });
    try {
      var url = new URL(location.href);
      url.searchParams.set('variant', treffer.id.split('/').pop());
      history.replaceState({}, '', url);
    } catch (e) {}
  }

  root.querySelectorAll('[data-alu-laenge]').forEach(function (b) {
    b.addEventListener('click', function () {
      auswahl.laenge = b.dataset.aluLaenge;
      ausgleichen();
      chipsMarkieren();
      chipsVerfuegbar();
      varianteSetzen();
      summeZeichnen();
      zustaende();
    });
  });
  root.querySelectorAll('[data-alu-farbe]').forEach(function (b) {
    b.addEventListener('click', function () {
      auswahl.farbe = b.dataset.aluFarbe;
      ausgleichen();
      chipsMarkieren();
      chipsVerfuegbar();
      varianteSetzen();
      summeZeichnen();
      zustaende();
    });
  });

  // Startzustand aus der vorausgewählten Variante
  (function () {
    var start = varianten.filter(function (v) { return v.available; })[0] || varianten[0];
    if (start) {
      auswahl.laenge = start.option2;
      auswahl.farbe = start.option1;
      chipsMarkieren();
      chipsVerfuegbar();
      varianteSetzen();
    }
  })();

  farbenZeigen();
  vorschau(formGewaehlt());
  kappenZeigen();
  summeZeichnen();
  zustaende();
})();
